module.exports = __webpack_public_path__ + "img/tarj3-1.44f9eea7.svg";